import { useCallback, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { cn } from 'src/utils/cx'
import css from '../Landing.module.css'
import { useFadeUp } from './useFadeUp'

const FAQ_COUNT = 6

export default function FAQSection() {
  const { t } = useTranslation('blackboard', { keyPrefix: 'welcome' })
  const [openIdx, setOpenIdx] = useState<number | null>(null)
  const fadeRef = useFadeUp()

  const toggle = useCallback((i: number) => {
    setOpenIdx(prev => (prev === i ? null : i))
  }, [])

  return (
    <section
      id="faq"
      className="py-24"
      style={{ background: 'var(--landing-pink-bg2)' }}
    >
      <div className="mx-auto max-w-[1200px] px-6">
        <div ref={fadeRef} className={cn(css.fadeUp, 'text-center')}>
          <h2 className="mb-4 text-4xl font-semibold leading-tight text-gray-900">
            <Trans
              i18nKey="blackboard:welcome.faq.heading"
              components={{
                highlight: <span className={css.gradientText} />,
              }}
            />
          </h2>
        </div>

        <div className="mx-auto mt-12 flex max-w-[720px] flex-col gap-3">
          {Array.from({ length: FAQ_COUNT }, (_, i) => (
            <div
              key={i}
              className={cn(
                'overflow-hidden rounded-2xl border-[1.5px] bg-white transition-colors',
                openIdx === i
                  ? 'border-[--landing-pink-light]'
                  : 'border-gray-200 hover:border-[--landing-pink-light]',
              )}
            >
              <button
                onClick={() => toggle(i)}
                className="flex w-full items-center justify-between px-6 py-5 text-left text-base font-semibold text-gray-800 transition-colors hover:text-[--landing-pink]"
              >
                {t(`faq.items.${i}.q`)}
                <span
                  className={cn(
                    'ml-4 shrink-0 text-xl text-gray-400 transition-transform',
                    openIdx === i && 'rotate-45 text-[--landing-pink]',
                  )}
                >
                  +
                </span>
              </button>
              <div
                className="overflow-hidden transition-all"
                style={{
                  maxHeight: openIdx === i ? '1000px' : '0',
                }}
              >
                <div className="px-6 pb-5 text-sm leading-relaxed text-gray-500">
                  {t(`faq.items.${i}.a`)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
